// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IDependentInfoReducedDto
 */
export interface IDependentInfoReducedDto {
    /**
     * 
     * @type {string}
     * @memberof IDependentInfoReducedDto
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IDependentInfoReducedDto
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IDependentInfoReducedDto
     */
    relationship_type?: IDependentInfoReducedDtoRelationshipTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum IDependentInfoReducedDtoRelationshipTypeEnum {
    SPOUSE = 'SPOUSE',
    CHILD = 'CHILD',
    DOMESTIC_PARTNER = 'DOMESTIC_PARTNER',
    OTHER = 'OTHER'
}


/**
 * Check if a given object implements the IDependentInfoReducedDto interface.
 */
export function instanceOfIDependentInfoReducedDto(value: object): value is IDependentInfoReducedDto {
    return true;
}

export function IDependentInfoReducedDtoFromJSON(json: any): IDependentInfoReducedDto {
    return IDependentInfoReducedDtoFromJSONTyped(json, false);
}

export function IDependentInfoReducedDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IDependentInfoReducedDto {
    if (json == null) {
        return json;
    }
    return {
        
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'relationship_type': json['relationship_type'] == null ? undefined : json['relationship_type'],
    };
}

export function IDependentInfoReducedDtoToJSON(json: any): IDependentInfoReducedDto {
    return IDependentInfoReducedDtoToJSONTyped(json, false);
}

export function IDependentInfoReducedDtoToJSONTyped(value?: IDependentInfoReducedDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'relationship_type': value['relationship_type'],
    };
}

